import { css } from 'styled-components';

import BpSans100 from '/shared/fonts/BpSans/bpSans-Thin.ttf';
import BpSans300 from '/shared/fonts/BpSans/bpSans-Light.ttf';
import BpSans400 from '/shared/fonts/BpSans/bpSans-Regular.ttf';
import BpSans500 from '/shared/fonts/BpSans/bpSans-Medium.ttf';
import BpSans700 from '/shared/fonts/BpSans/bpSans-Bold.ttf';
import BpSans900 from '/shared/fonts/BpSans/bpSans-Black.ttf';

// This function is used for running the test suite, please refer to '/shared/fonts/Roboto/stylesheet.css' for font styling
export default function fontsStyle() {
  return css`
    @font-face {
      font-family: 'BpSans';
      src: url(${BpSans100}) format('truetype');
      font-weight: 100;
      font-style: normal;
    }

    @font-face {
      font-family: 'BpSans';
      src: url(${BpSans300}) format('truetype');
      font-weight: 300;
      font-style: normal;
    }

    @font-face {
      font-family: 'BpSans';
      src: url(${BpSans400}) format('truetype');
      font-weight: 400;
      font-style: normal;
    }

    @font-face {
      font-family: 'BpSans';
      src: url(${BpSans500}) format('truetype');
      font-weight: 500;
      font-style: normal;
    }

    @font-face {
      font-family: 'BpSans';
      src: url(${BpSans700}) format('truetype');
      font-weight: 700;
      font-style: normal;
    }

    @font-face {
      font-family: 'BpSans';
      src: url(${BpSans900}) format('truetype');
      font-weight: 900;
      font-style: normal;
    }
  `;
}
